"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateHeldCoverNoteDto = exports.HeldCoverNoteDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const create_held_cover_note_dto_1 = require("./create-held-cover-note.dto");
class HeldCoverNoteDocumentDto {
}
exports.HeldCoverNoteDocumentDto = HeldCoverNoteDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Id",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentDto.prototype, "documentId", void 0);
class UpdateHeldCoverNoteDto {
}
exports.UpdateHeldCoverNoteDto = UpdateHeldCoverNoteDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 479,
        description: "Opportunity Activity ID(mandatory field)",
    }),
    (0, class_validator_1.IsInt)({ message: "Opportunity Activity ID must be an integer" }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdateHeldCoverNoteDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 404,
        description: "Status",
    }),
    (0, class_validator_1.IsInt)({ message: "Status must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], UpdateHeldCoverNoteDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: create_held_cover_note_dto_1.PlacementSlipDeviationsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_held_cover_note_dto_1.PlacementSlipDeviationsDto),
    tslib_1.__metadata("design:type", typeof (_a = typeof create_held_cover_note_dto_1.PlacementSlipDeviationsDto !== "undefined" && create_held_cover_note_dto_1.PlacementSlipDeviationsDto) === "function" ? _a : Object)
], UpdateHeldCoverNoteDto.prototype, "placementSlipDeviationsSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: create_held_cover_note_dto_1.DeviationsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_held_cover_note_dto_1.DeviationsDto),
    tslib_1.__metadata("design:type", typeof (_b = typeof create_held_cover_note_dto_1.DeviationsDto !== "undefined" && create_held_cover_note_dto_1.DeviationsDto) === "function" ? _b : Object)
], UpdateHeldCoverNoteDto.prototype, "deviationSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: create_held_cover_note_dto_1.DeviationsAddressedDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_held_cover_note_dto_1.DeviationsAddressedDto),
    tslib_1.__metadata("design:type", typeof (_c = typeof create_held_cover_note_dto_1.DeviationsAddressedDto !== "undefined" && create_held_cover_note_dto_1.DeviationsAddressedDto) === "function" ? _c : Object)
], UpdateHeldCoverNoteDto.prototype, "deviationsAddressedSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: create_held_cover_note_dto_1.PremiumReceiptDetailsDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_held_cover_note_dto_1.PremiumReceiptDetailsDto),
    tslib_1.__metadata("design:type", typeof (_d = typeof create_held_cover_note_dto_1.PremiumReceiptDetailsDto !== "undefined" && create_held_cover_note_dto_1.PremiumReceiptDetailsDto) === "function" ? _d : Object)
], UpdateHeldCoverNoteDto.prototype, "premiumReceiptDetailsSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: create_held_cover_note_dto_1.RemarksDto }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_held_cover_note_dto_1.RemarksDto),
    tslib_1.__metadata("design:type", typeof (_e = typeof create_held_cover_note_dto_1.RemarksDto !== "undefined" && create_held_cover_note_dto_1.RemarksDto) === "function" ? _e : Object)
], UpdateHeldCoverNoteDto.prototype, "remarksSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of documents",
        type: [HeldCoverNoteDocumentDto],
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => HeldCoverNoteDocumentDto),
    tslib_1.__metadata("design:type", Array)
], UpdateHeldCoverNoteDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Created By",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Created By must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], UpdateHeldCoverNoteDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 2,
        description: "Updated By",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Updated By must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], UpdateHeldCoverNoteDto.prototype, "updatedBy", void 0);
